/** Recording format: browsers differ (Chrome/Android webm, Safari/iPhone mp4). Map to the server's file types. */
export const pickAudioMime = (isSupported: (m: string) => boolean): string | null => {
  for (const m of ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg;codecs=opus", "audio/mpeg"]) {
    if (isSupported(m)) return m;
  }
  return null;
};

/** The server's file type is sent as its mime string, e.g. "audio/webm". */
export const fileTypeFor = (mime: string): string => {
  if (mime.startsWith("audio/webm")) return "audio/webm";
  if (mime.startsWith("audio/mp4")) return "audio/mp4";
  if (mime.startsWith("audio/ogg")) return "audio/ogg";
  return "audio/mpeg";
};

export const seconds = (ms: number): string => {
  const s = Math.round(ms / 1000);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

/** Notes are short explanations; stop at two minutes. */
export const MAX_MS = 120_000;
